import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Leaf } from "@phosphor-icons/react";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <Leaf size={48} weight="duotone" color="#8A9A86" className="animate-pulse" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
